module.exports = __webpack_public_path__ + "static/media/29BDOS21.b70ab7e1.jpg";